import mediator from "@tvg/mediator";

export const onFillValidatedInputGtmEvent = (label, module, isEditing) =>
  mediator.base.dispatch({
    type: "REGISTRATION:FIELD_FILL_AND_VALIDATED",
    payload: {
      label,
      module,
      isEditing
    }
  });

export const onErrorInputGtmEvent = (label, module, isEditing) =>
  mediator.base.dispatch({
    type: "REGISTRATION:FIELD_ERROR",
    payload: {
      label,
      module,
      isEditing
    }
  });
